import { Button, Col, Form, Image, Input, InputNumber, Row, Select, Table } from 'antd';
import { useEffect, useState } from 'react';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function FormCategoryBonus() {
    const token = useSelector((state) => state.user.token);
    const navigate = useNavigate();
    const location = useLocation();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [data2, setData2] = useState([]);
    const [page, setPage] = useState(1);
    const [page2, setPage2] = useState(1);
    const [category, setCategory] = useState([]);

    const [loading, setLoading] = useState(false);
    const [product, setProduct] = useState([]);
    const [variant, setVariant] = useState([]);
    const [productValue, setProductValue] = useState();
    const [variantValue, setVariantValue] = useState();
    const [categoryValue, setCategoryValue] = useState();

    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
             sorter: false,
            render: (text, record, index) => (page - 1) * 10 + index + 1
        },
        {
            title: 'Gambar',
            dataIndex: 'Images',
            key: "Images",
             sorter: false,
            render: (text, record) => {
                return (
                    <Image
                        width={40}
                        height={40}
                        src={record.image}
                        fallback="data:image/png;base64,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"
                    />
                );
            }
        },
        {
            title: 'Nama Produk',
            dataIndex: 'ProductName',
            key: "ProductName",
             sorter: false,
            render: (text, record) => {
                var productname;
                if (record.variant_name != null) {
                    productname = record.product_name + ' - ' + record.variant_name;
                } else {
                    productname = record.product_name;
                }
                return (<p>{productname}</p>);
            }
        },
        {
            title: 'Minimal Beli',
            dataIndex: 'min_order',
            key: "min_order",
             sorter: false,
            render: (text, record, index) => {
                return (
                    <InputNumber
                        key={(page - 1) * 10 + index}
                        onChange={(ev) => onInputTable(ev, index, 'min_order')}
                        placeholder='Minimal Pembelian'
                        defaultValue={record.min_order}
                    />
                );
            }
        },
        // {
        //     title: 'Harga',
        //     dataIndex: 'price',
        //     key: "price",
        //      sorter: false,
        //     render: (text, record, index) => {
        //         return (
        //             <InputNumber
        //                 addonBefore="Rp."
        //                 style={{
        //                     width: "90%",
        //                 }}
        //                 key={(page - 1) * 10 + index }
        //                 onChange={(ev) => onInputTable(ev, index, 'price')}
        //                 placeholder='Harga'
        //                 defaultValue={record.price}
        //                 formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        //                 parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
        //             />
        //         );
        //     }
        // },
        {
            title: 'Action',
            dataIndex: 'Action',
            key: "Action",
             sorter: false,
            render: (text, record, index) => {
                return (
                    <Button type="text" onClick={() => deleteRow(index)}>
                        <CloseOutlined style={{ color: "red" }} size={25} />
                    </Button>
                );
            }
        },
    ];

    const columns2 = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
             sorter: false,
            render: (text, record, index) => (page2 - 1) * 10 + index + 1
        },
        {
            title: 'Gambar',
            dataIndex: 'Images',
            key: "Images",
             sorter: false,
            render: (text, record) => {
                return (
                    <Image
                        width={40}
                        height={40}
                        src={record.image}
                        fallback="data:image/png;base64,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"
                    />
                );
            }
        },
        {
            title: 'Nama Produk',
            dataIndex: 'ProductName',
            key: "ProductName",
             sorter: false,
            render: (text, record) => {
                var productname;
                if (record.variant_name != null) {
                    productname = record.product_name + ' - ' + record.variant_name;
                } else {
                    productname = record.product_name;
                }
                return (<p>{productname}</p>);
            }
        },
        {
            title: 'Qty',
            dataIndex: 'qty',
            key: "qty",
             sorter: false,
            render: (text, record, index) => {
                return (
                    <InputNumber
                        key={(page - 1) * 10 + index}
                        onChange={(ev) => onInputTable2(ev, index, 'qty')}
                        placeholder='Qty'
                        defaultValue={record.qty}
                    />
                );
            }
        },
        // {
        //     title: 'Harga',
        //     dataIndex: 'price',
        //     key: "price",
        //      sorter: false,
        //     render: (text, record, index) => {
        //         return (
        //             <InputNumber
        //                 addonBefore="Rp."
        //                 style={{
        //                     width: "90%",
        //                 }}
        //                 key={(page - 1) * 10 + index }
        //                 onChange={(ev) => onInputTable2(ev, index, 'price')}
        //                 placeholder='Harga'
        //                 defaultValue={record.price}
        //                 formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        //                 parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
        //             />
        //         );
        //     }
        // },
        {
            title: 'Action',
            dataIndex: 'Action',
            key: "Action",
             sorter: false,
            render: (text, record, index) => {
                return (
                    <Button type="text" onClick={() => deleteRow2(index)}>
                        <CloseOutlined style={{ color: "red" }} size={25} />
                    </Button>
                );
            }
        },
    ];

    useEffect(() => {
        getApi('GET', '/category?nopage=true', 'category');
        getApi("GET", '/selectproduct?nopage=true', 'product');
        if (location.state != null) {
            const item = location.state.item;
            getApi("GET", '/productpackage/' + item.group_package_id, 'productDetail');
            form.setFieldsValue({
                name: item.name,
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const deleteRow = (index) => {
        var row = [...data];
        row.splice(index, 1);
        setData(row);
    }

    const deleteRow2 = (index) => {
        var row = [...data2];
        row.splice(index, 1);
        setData2(row);
    }

    const save = (ev) => {
        const state = location.state;
        var method = 'POST';
        if (state != null) {
            ev.group_package_id = state.item.group_package_id;
            method = "PUT";
        } else {
            method = "POST";
        }
        ev.product_package = data;
        ev.bonus_package = data2;
        getApi(method, '/productpackage', 'form', ev);
    }

    const getApi = async (method, url, type, values = null) => {
        const dataReq = {
            method: method,
            url: url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token,
                }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                switch (type) {
                    case 'category':
                        var category = res.data;
                        var row = [];
                        for (let i = 0; i < category.length; i++) {
                            row.push({
                                value: category[i].category_id,
                                label: category[i].category_name,
                            });
                        }
                        setCategory(row);
                        setLoading(false);
                        break;
                    case 'product':
                        var product = res.data.rows;
                        var row = [];
                        for (let i = 0; i < product.length; i++) {
                            row.push({
                                value: JSON.stringify(product[i]),
                                label: product[i].product_name,
                            });
                        }
                        setProduct(row);
                        setLoading(false);
                        break;
                    case 'productDetail':
                        var item = res.data;
                        var product_package = [];
                        var bonus_package = [];
                        if (item.product_packages !== null) {
                            for (let i = 0; i < item.product_packages.length; i++) {
                                var pp = item.product_packages[i]
                                var prod = pp.product;
                                var vari = pp.variant_product;
                                product_package.push({
                                    id: Number(prod.product_id) + Number(vari.variant_product_id),
                                    product_id: prod.product_id,
                                    variant_product_id: vari.variant_product_id,
                                    image: vari.image,
                                    price: vari.price,
                                    sku: vari.SKU,
                                    product_name: prod.product_name,
                                    variant_name: vari.variant_name,
                                    min_order: pp.min_order
                                })
                            }
                        }
                        if (item.bonus_package !== null) {
                            for (let i = 0; i < item.bonus_packages.length; i++) {
                                var bp = item.bonus_packages[i]
                                var prod2 = bp.product;
                                var vari2 = bp.variant_product;
                                bonus_package.push({
                                    id: Number(prod2.product_id) + Number(vari2.variant_product_id),
                                    product_id: prod2.product_id,
                                    variant_product_id: vari2.variant_product_id,
                                    image: vari2.image,
                                    price: vari2.price,
                                    sku: vari2.SKU,
                                    product_name: prod2.product_name,
                                    variant_name: vari2.variant_name,
                                    qty: bp.qty
                                })
                            }
                        }
                        setData(product_package);
                        setData2(bonus_package);
                        break;
                    default:
                        navigate(-1);
                        break;
                }
            } else {
                modalError(res.message);
            }
        }).catch((e) => {
            console.log(e);
        })
    }

    const selectData = (event, type) => {
        var json_arr = JSON.parse(event);
        var row = [];
        if (type === 'product') {
            setProductValue(JSON.stringify(json_arr));
            // form.setFieldsValue({
            //     variant_product_id: null,
            //     price: null,
            // })
            for (let i = 0; i < json_arr.variant_products.length; i++) {
                row.push({
                    value: JSON.stringify(json_arr.variant_products[i]),
                    label: json_arr.variant_products[i].variant_name !== null ? json_arr.variant_products[i].variant_name : json_arr.variant_products[i].SKU,
                });
            }
            setVariantValue(null);
            setVariant(row);
            
        } else {
            setVariantValue(JSON.stringify(json_arr));
        }
    }

    const onInputTable = (ev, index, type) => {
        var i = (page - 1) * 10 + index;
        data[i][type] = ev;
        setData(data);
    }

    const onInputTable2 = (ev, index, type) => {
        var i = (page - 1) * 10 + index;
        data[i][type] = ev;
        setData2(data);
    }

    const saveProduct = () => {
        if (productValue !== null) {
            var prod = JSON.parse(productValue);
            var vari = JSON.parse(variantValue);
            if (variantValue !== null) {
                var status_duplicate = false;
                for (let i = 0; i < data.length; i++) {
                    if (data[i].product_id === prod.product_id && data[i].variant_product_id === vari.variant_product_id) {
                        status_duplicate = true;
                    }
                }
                if (status_duplicate === false) {
                    var arr_prod = {
                        id: Number(prod.product_id) + Number(vari.variant_product_id),
                        product_id: prod.product_id,
                        variant_product_id: vari.variant_product_id,
                        image: vari.image,
                        sku: vari.SKU,
                        product_name: prod.product_name,
                        variant_name: vari.variant_name,
                        min_order: 1
                    }
                    var item = arr_prod;
                    let setDatas = [].concat(data, item);
                    setData(setDatas);
                    setProductValue(null);
                    setVariantValue(null);
                } else {
                    modalError('Produk ini sudah ditambah');
                }
            } else {
                modalError('Varian Kosong');
            }
        } else {
            modalError('Produk Kosong');
        }
    }


    const saveBonusProduct = () => {
        if (productValue !== null) {
            var prod = JSON.parse(productValue);
            var vari = JSON.parse(variantValue);
            if (variantValue !== null) {
                var status_duplicate = false;
                for (let i = 0; i < data2.length; i++) {
                    if (data2[i].product_id === prod.product_id && data2[i].variant_product_id === vari.variant_product_id) {
                        status_duplicate = true;
                    }
                }
                if (status_duplicate === false) {
                    var arr_prod = {
                        id: prod.product_id + vari.variant_product_id,
                        product_id: prod.product_id,
                        variant_product_id: vari.variant_product_id,
                        image: vari.image,
                        sku: vari.SKU,
                        product_name: prod.product_name,
                        variant_name: vari.variant_name,
                        qty: 1
                    }
                    var item = arr_prod;
                    let setDatas = [].concat(data2, item);
                    setData2(setDatas);
                    setProductValue(null);
                    setVariantValue(null);
                } else {
                    modalError('Produk ini sudah ditambah');
                }
            } else {
                modalError('Varian Kosong');
            }
        } else {
            modalError('Produk Kosong');
        }
    }

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="primary" onClick={form.submit} >
                    <b style={{ marginLeft: 5 }}>Simpan</b>
                </Button>
            </div>

            <Form form={form} name="form" layout="vertical" onFinish={save}>
                <Form.Item
                    name="name"
                    label="Nama Paket"
                    rules={[
                        {
                            required: true,
                            message: 'Nama Paket kosong!'
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Select
                            virtual={false}
                    showSearch
                    placeholder="Pilih Kategori"
                    optionFilterProp="label"
                    filterOption={(input, option) => String(option?.label ?? option?.children ?? '').toLowerCase().includes(String(input ?? '').toLowerCase())}
                    filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                    }
                    onChange={(ev) => setCategoryValue(ev)}
                    options={category}
                    value={categoryValue}
                    style={{ marginRight: 10, width: 300 }}
                />
                <Select
                            virtual={false}
                    showSearch
                    placeholder="Pilih Produk"
                    optionFilterProp="label"
                    filterOption={(input, option) => String(option?.label ?? option?.children ?? '').toLowerCase().includes(String(input ?? '').toLowerCase())}
                    filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                    }
                    onChange={(ev) => selectData(ev, 'product')}
                    options={product}
                    value={productValue}
                    style={{ marginRight: 10, width: 300 }}
                />
                {
                    variant !== null &&
                    <Select
                            virtual={false}
                        showSearch
                        placeholder="Pilih Varian"
                        optionFilterProp="label"
                        filterOption={(input, option) => String(option?.label ?? option?.children ?? '').toLowerCase().includes(String(input ?? '').toLowerCase())}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        onChange={(ev) => selectData(ev, 'variant')}
                        options={variant}
                        value={variantValue}
                        style={{ marginRight: 10, width: 300 }}
                    />
                }
                <Button
                    style={{ marginTop: 10, marginRight: 10, fontWeight: "bold" }}
                    onClick={() => saveProduct()}
                    type="primary">
                    Tambah Produk Beli <PlusOutlined />
                </Button>
                <Button
                    style={{ marginTop: 10, fontWeight: "bold" }}
                    onClick={() => saveBonusProduct()}
                    type="primary">
                    Tambah Bonus Produk <PlusOutlined />
                </Button>
            </Form>
            <Row style={{ marginTop: 20 }}>
                <Col span={11}>
                    <h3>Produk Dibeli</h3>
                    <Table
                        size="middle"
                        columns={columns}
                        dataSource={data}
                        loading={loading}
                        pagination={{
                            onChange(current) {
                                setPage(current);
                            }
                        }}
                    />
                </Col>
                <Col span={1} />
                <Col span={11}>
                    <h3>Bonus Produk</h3>
                    <Table
                        size="middle"
                        columns={columns2}
                        dataSource={data2}
                        loading={loading}
                        pagination={{
                            onChange(current) {
                                setPage2(current);
                            }
                        }}
                    />
                </Col>
            </Row>
        </div>
    );
}

export default FormCategoryBonus;